import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export function useMaintenanceMode() {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let subscriptionCleanup: (() => void) | null = null;
    
    const checkMaintenanceMode = async () => {
      try {
        const { data, error } = await supabase
          .from('settings')
          .select('value')
          .eq('key', 'maintenanceMode')
          .maybeSingle();

        if (error) {
          setIsMaintenanceMode(false);
        } else if (data) {
          setIsMaintenanceMode(data.value === true);
        } else {
          setIsMaintenanceMode(false);
        }
      } catch (error) {
        setIsMaintenanceMode(false);
      } finally {
        setLoading(false);
      }
    };

    // Defer maintenance check to avoid blocking initial render
    const timer = setTimeout(() => {
      checkMaintenanceMode();
    }, 0);

    // Defer subscription setup to avoid blocking
    const subscriptionTimer = setTimeout(() => {
      const subscription = supabase
        .channel('maintenance-mode')
        .on(
          'postgres_changes',
          {
            event: '*',
            schema: 'public',
            table: 'settings',
            filter: 'key=eq.maintenanceMode'
          },
          (payload) => {
            if (payload.new && typeof payload.new === 'object' && 'value' in payload.new) {
              setIsMaintenanceMode(payload.new.value === true);
            }
          }
        )
        .subscribe();

      subscriptionCleanup = () => subscription.unsubscribe();
    }, 1000);

    return () => {
      clearTimeout(timer);
      clearTimeout(subscriptionTimer);
      if (subscriptionCleanup) {
        subscriptionCleanup();
      }
    };
  }, []);

  return { isMaintenanceMode, loading };
}